export class CNPJValidator {
  static tamanhoCNPJSemDV = 12;
  static regexCNPJSemDV = /^([A-Z\d]){12}$/;
  static regexCNPJ = /^([A-Z\d]){12}(\d){2}$/;
  static regexCaracteresMascara = /[./-]/g;
  static regexCaracteresNaoPermitidos = /[^A-Z\d./-]/i;
  static valorBase = "0".charCodeAt(0);
  static pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  static cnpjZerado = "00000000000000";
  static valoresInvalidos = [
      "00000000000000",
      "11111111111111",
      "22222222222222",
      "33333333333333",
      "44444444444444",
      "55555555555555",
      "66666666666666",
      "77777777777777",
      "88888888888888",
      "99999999999999",
  ];

  /**
   * Verifica se o CNPJ fornecido é valido
   *
   * @param {string} cnpj
   * @returns {boolean}
   */
  static isValid(cnpj) {
    try {
      if (this.regexCaracteresNaoPermitidos.test(cnpj)) {
        return false;
      }

      const cnpjSemMascara = this.removeMascaraCNPJ(cnpj);

      if (!this.regexCNPJ.test(cnpjSemMascara) || this.valoresInvalidos.includes(cnpjSemMascara)) {
        return false;
      }

      const dvInformado = cnpjSemMascara.substring(this.tamanhoCNPJSemDV);
      const dvCalculado = this.calculaDV(cnpjSemMascara.substring(0, this.tamanhoCNPJSemDV));
      return dvInformado === dvCalculado;
    } catch {
      return false;
    }
  }

  static calculaDV(cnpj) {
    if (this.regexCaracteresNaoPermitidos.test(cnpj)) {
      throw new Error("Não é possível calcular o DV pois o CNPJ fornecido é inválido");
    }

    const cnpjSemMascara = this.removeMascaraCNPJ(cnpj);

    if (!this.regexCNPJSemDV.test(cnpjSemMascara) && cnpjSemMascara === this.cnpjZerado.substring(0, this.tamanhoCNPJSemDV)) {
      throw new Error("Não é possível calcular o DV pois o CNPJ fornecido é inválido");
    }

    let somatorioDV1 = 0;
    let somatorioDV2 = 0;

    for (let i = 0; i < this.tamanhoCNPJSemDV; i++) {
      const asciiDigito = cnpjSemMascara.charCodeAt(i) - this.valorBase;
      somatorioDV1 += asciiDigito * this.pesosDV[i + 1];
      somatorioDV2 += asciiDigito * this.pesosDV[i];
    }

    const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
    somatorioDV2 += dv1 * this.pesosDV[this.tamanhoCNPJSemDV];
    const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

    return `${dv1}${dv2}`;
  }

  static removeMascaraCNPJ(cnpj) {
    return cnpj.replace(this.regexCaracteresMascara, "");
  }
}
